import { formatDatetime, cap } from '../../utilities/utilities';
import Boolean from './Boolean';
import TypedInput from './TypedInput';
import Select from './Select';

const showDataType = false

const inputDataTypes = [ 'text', 'numeric', 'date', 'time', 'timestamp', 'uuid', 'jsonb', 'integer' ]

const selects = { 
	'template':    { api: "templates-list",  titleKey: "name", titleValue: "title" }, 
	'category_id': { api: "categories-list", titleKey: "id",   titleValue: "title"}, 
	'cruise_id':   { api: "cruises-list",    titleKey: "id",   titleValue: "title"}, 
	'page_id':     { api: "pages",           titleKey: "id",   titleValue: "title"}, 
}

export default function Row( props ) {

	const c = props.c 
	const data = props.data
	const setData = props.setData
	const immutables = props.immutables

	return(
		<tr key={ c.column_name } >
			<td style={{ whiteSpace:'pre', padding:'8px 12px', fontWeight:700 }} >
				{ cap( c.column_name ) }
			</td>
			{ !immutables.includes( c.column_name ) 
			  ? <td style={{ whiteSpace:'pre', padding:0 }} >

					{ c.data_type === 'boolean' && 
						<Boolean c={ c } data={ data } setData={ setData } />
					}

					{ selects.hasOwnProperty( c.column_name ) && 
						<Select 
							c={ c } data={ data } setData={ setData } 
							api={ selects[ c.column_name ].api }
							titleKey={ selects[ c.column_name ].titleKey }
							titleValue={ selects[ c.column_name ].titleValue }
						/>
					}

					{ !selects.hasOwnProperty( c.column_name ) && inputDataTypes.includes( c.data_type ) && 
						<TypedInput c={ c } data={ data } setData={ setData } />
					}

				</td>
			  : <td style={{ whiteSpace:'pre', userSelect:'all', padding:'6px 12px', fontWeight:500, fontSize:15, background:'#f4f4f4' }} >
					{ data[ c.column_name ] }
				</td>
			}

			{ showDataType && 
				<td style={{ whiteSpace:'pre', padding:'8px 16px', fontWeight:400 }} >
					{ cap( c.data_type ) }
				</td>
			}

		</tr>
	)
}
